var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClarityCircleArrowSolids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9815_27200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5547 21.9999C41.5547 18.1322 40.4078 14.3513 38.259 11.1354C36.1102 7.91952 33.056 5.41304 29.4827 3.93292C25.9094 2.45281 21.9774 2.06554 18.184 2.8201C14.3906 3.57465 10.9062 5.43714 8.17126 8.17203C5.43637 10.9069 3.57389 14.3914 2.81933 18.1848C2.06477 21.9782 2.45204 25.9102 3.93215 29.4835C5.41227 33.0568 7.91875 36.111 11.1346 38.2598C14.3505 40.4085 18.1314 41.5555 21.9991 41.5555C27.1856 41.5555 32.1596 39.4951 35.827 35.8278C39.4944 32.1604 41.5547 27.1864 41.5547 21.9999ZM22.5247 31.7777C22.2052 31.4511 22.0263 31.0124 22.0263 30.5555C22.0263 30.0986 22.2052 29.6598 22.5247 29.3332L28.1102 23.711L10.828 23.711C10.3742 23.711 9.93898 23.5307 9.61808 23.2098C9.29719 22.8889 9.11691 22.4537 9.11691 21.9999C9.11691 21.5461 9.29719 21.1109 9.61808 20.79C9.93898 20.4691 10.3742 20.2888 10.828 20.2888L27.9391 20.2888L22.5247 14.8743C22.2005 14.5502 22.0184 14.1105 22.0184 13.6521C22.0184 13.1937 22.2005 12.7541 22.5247 12.4299C22.8488 12.1057 23.2885 11.9236 23.7469 11.9236C24.2053 11.9236 24.645 12.1057 24.9691 12.4299L34.588 22.0977L24.9447 31.7777C24.7858 31.9366 24.5972 32.0626 24.3895 32.1486C24.1819 32.2346 23.9594 32.2789 23.7347 32.2789C23.51 32.2789 23.2874 32.2346 23.0798 32.1486C22.8722 32.0626 22.6836 31.9366 22.5247 31.7777Z",
    fill: "#F2F2F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9815_27200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "matrix(0 1 -1 0 44 0)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityCircleArrowSolids);
export default __webpack_public_path__ + "static/media/clarity_circle-arrow-solids.fc6a97844e59306a8bb47bc03d5325c3.svg";
export { ForwardRef as ReactComponent };